import {useEffect} from 'react';
import {ICoord} from '../models/coord.model';
import {useSearchParams} from "react-router-dom";
import {GOOGLE_MAPS_DEFAULT_MAP_CENTER_COORD} from '../util/google.constants';
import {geocodeByAddress} from "react-google-places-autocomplete";

export interface IInitializeMapCenter {
  isMapCenterInitialized: boolean,

  setMapCenterCoord(value: ICoord, forceUpdate: boolean): void,

  setMapFitBounds(bounds?: google.maps.LatLngBounds): void,

  setToUserLocation(doCenterMap?: boolean, backupCoord?: ICoord, doAlert?: boolean): void
}

export const InitializeMapCenter: React.FC<IInitializeMapCenter> = props => {
  const [searchParams,] = useSearchParams();

  useEffect(() => {
    if (!props.isMapCenterInitialized) {
      const latLng = searchParams.get('x') !== null ? JSON.parse(searchParams.get('x')!) : null;
      const rawBounds = searchParams.get('b') !== null ? JSON.parse(searchParams.get('b')!) : null;
      const loctext = searchParams.get('l') !== null ? searchParams.get('l')!.trim() : null;
      if (latLng !== null && latLng[0] !== undefined && latLng[1] !== undefined && latLng[0] !== 0) {
        props.setMapCenterCoord({lat: latLng[0], lng: latLng[1]}, true);
      } else if (rawBounds !== null) {
        const bounds = new google.maps.LatLngBounds(
          {lat: rawBounds[0], lng: rawBounds[1]},
          {lat: rawBounds[2], lng: rawBounds[3]}
        );
        props.setMapFitBounds(bounds);
      } else if (loctext !== null) {
        // console.log(loctext);
        geocodeByAddress(loctext)
          .then(results => {
            if (results.length > 0) {
              props.setMapFitBounds(results[0].geometry.viewport);
            }
          })
      } else {
        props.setToUserLocation(true, GOOGLE_MAPS_DEFAULT_MAP_CENTER_COORD, false);
      }
    }
  });
  return null;
};

export default InitializeMapCenter;